(function () {
  "use strict";

  if (window.__elaveKlaviyoCartStateLoaded) return;
  window.__elaveKlaviyoCartStateLoaded = true;

  var nativeFetch = window.fetch.bind(window);
  var nativeXhrOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var debounceTimer;
  var storageKey = "elave-klaviyo-cart-state-v2";

  function moneyFromCents(value) {
    var cents = Number(value);
    return Number.isFinite(cents) ? Number((cents / 100).toFixed(2)) : 0;
  }

  function absoluteUrl(value) {
    if (!value) return "";
    try {
      return new URL(value, window.location.origin).href;
    } catch (_error) {
      return String(value);
    }
  }

  function normalizeItems(cart) {
    var byVariant = new Map();

    (cart && Array.isArray(cart.items) ? cart.items : []).forEach(function (item) {
      var variantId = String(item.variant_id || item.id || "");
      if (!variantId) return;

      var quantity = Math.max(0, Number(item.quantity) || 0);
      if (!quantity) return;

      if (byVariant.has(variantId)) {
        byVariant.get(variantId).Quantity += quantity;
        return;
      }

      byVariant.set(variantId, {
        "Product Name": item.product_title || item.title || "Elave product",
        "Image URL": absoluteUrl(item.featured_image && item.featured_image.url ? item.featured_image.url : item.image),
        Price: moneyFromCents(item.final_price != null ? item.final_price : item.price),
        Currency: cart.currency || "EUR",
        "Variant ID": variantId,
        Quantity: quantity,
        URL: absoluteUrl(item.url),
      });
    });

    return Array.from(byVariant.values());
  }

  function buildCartUrl(items) {
    var cartPath = root.replace(/\/?$/, "/") + "cart";
    if (!items.length) return window.location.origin + cartPath;

    var lines = items.map(function (item) {
      return encodeURIComponent(item["Variant ID"]) + ":" + encodeURIComponent(item.Quantity);
    });
        return window.location.origin + cartPath + "/" + lines.join(",");
  }

  function createSnapshot(cart) {
    var items = normalizeItems(cart);
    return {
      "Latest Cart Line Count": items.length,
      "Latest Cart Quantity Total": items.reduce(function (total, item) {
        return total + item.Quantity;
      }, 0),
      "Latest Cart Items": items,
      "Latest Cart URL": buildCartUrl(items),
      "Latest Cart Updated At": new Date().toISOString(),
    };
  }

  function signature(snapshot) {
    return JSON.stringify({
      lineCount: snapshot["Latest Cart Line Count"],
      quantityTotal: snapshot["Latest Cart Quantity Total"],
      items: snapshot["Latest Cart Items"],
      url: snapshot["Latest Cart URL"],
    });
  }

  function lastSignature() {
    try {
      return window.sessionStorage.getItem(storageKey) || "";
    } catch (_error) {
      return "";
    }
  }

  function rememberSignature(value) {
    try {
      window.sessionStorage.setItem(storageKey, value);
    } catch (_error) {
      // Cart recovery must continue even when storage is disabled.
    }
  }

  function identify(snapshot) {
    window._learnq = window._learnq || [];
    window._learnq.push(["identify", snapshot]);

    if (window.klaviyo && window.klaviyo !== window._learnq && typeof window.klaviyo.push === "function") {
      window.klaviyo.push(["identify", snapshot]);
    }
  }

  async function syncNow(force) {
    try {
      var response = await nativeFetch(root.replace(/\/?$/, "/") + "cart.js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return null;

      var cart = await response.json();
      var snapshot = createSnapshot(cart);
      var nextSignature = signature(snapshot);
      if (!force && nextSignature === lastSignature()) return snapshot;

      identify(snapshot);
      rememberSignature(nextSignature);
      window.dispatchEvent(new CustomEvent("elave:cart-snapshot", { detail: snapshot }));
      return snapshot;
    } catch (_error) {
      return null;
    }
  }

  function scheduleSync(force) {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () {
      syncNow(Boolean(force));
    }, 180);
  }

  function isCartMutation(input) {
    var value = typeof input === "string" ? input : input && input.url;
    if (!value) return false;
    try {
      var pathname = new URL(value, window.location.origin).pathname;
      return /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(pathname);
    } catch (_error) {
      return false;
    }
  }

  window.fetch = function () {
    var args = arguments;
    var shouldSync = isCartMutation(args[0]);
    return nativeFetch.apply(window, args).then(function (response) {
      if (shouldSync && response.ok) scheduleSync(true);
      return response;
    });
  };

  if (nativeXhrOpen) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__elaveCartMutation = isCartMutation(url);
      if (this.__elaveCartMutation) {
        this.addEventListener("loadend", function () {
          if (this.status >= 200 && this.status < 400) scheduleSync(true);
        });
      }
      return nativeXhrOpen.apply(this, arguments);
    };
  }

  ["cart:update", "cart:reload", "cart:drawer:render", "cart:main:render", "cart:count:update"].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      scheduleSync(true);
    });
  });

  window.ElaveCartSnapshot = {
    normalizeItems: normalizeItems,
    buildCartUrl: buildCartUrl,
    createSnapshot: createSnapshot,
    syncNow: syncNow,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleSync(false);
    }, { once: true });
  } else {
    scheduleSync(false);
  }
})();
